






















import { defineComponent, ref } from "@vue/composition-api";
import providers from "@/lib/api";
import BaseConfirm from "@/components/BaseConfirm";
import SixDigitConfirmView from "@/components/SixDigitConfirmView";

export default defineComponent({
  name: "PhoneVerifyModal",
  components: { BaseConfirm, SixDigitConfirmView },
  props: {
    show: { type: Boolean, default: false },
    phone: { type: String, required: true },
  },
  setup(props, { emit }) {
    const processing = ref(false);

    const resendCode = () => {
      providers.PhoneVerificationProvider.start({ phone: props.phone });
    };

    const confirmCode = async (code: string) => {
      try {
        processing.value = true;
        await providers.PhoneVerificationProvider.confirm({
          data: { phone: props.phone, code },
        });
        emit("verified");
      } finally {
        processing.value = false;
      }
    };

    return {
      processing,
      resendCode,
      confirmCode,
    };
  },
});
